import React, { FC } from 'react';
import { components, ControlProps } from 'react-select';

export type IControl = FC<ControlProps<any, false>>;

export const Control: IControl = props => {
  const { children } = props;

  return <components.Control {...props}>{children}</components.Control>;
};
